<div class="card-body">
    <div id="apex-donut-with-pattern-chart"></div>
</div>